<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="my-10 px-4">
      <div class="flex justify-between items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">{{ __('Order #:id notifications', { id: job.id }) }}</h1>
        <div class="sm:ml-6">
          <inertia-link :disabled="!job.permissions.update" :href="route('actionRequests.create', {job: job.id})" class="btn-primary">
            {{ __('New notification') }}
          </inertia-link>
        </div>
      </div>

      <div class="bg-white p-4 shadow-md mt-10 overflow-x-auto">
        <table class="min-w-md w-full" v-if="actionRequests.data.length" aria-describedby="Job action requests table">
          <tr class="bg-gray-700 text-gray-100">
            <th id="actionRequest-id" class="p-4 w-10">{{ __('Id') }}</th>
            <th id="actionRequest-type" class="p-4 text-left w-full">{{ __('Type') }}</th>
            <th id="actionRequest-client-link" class="p-4 text-left w-full">{{ __('Excerpt') }}</th>
            <th id="actionRequest-user" class="p-4 text-left min-w-48">{{ __('User') }}</th>
            <th id="actionRequest-createdAt" class="p-4 text-left min-w-48">{{ __('Sent') }}</th>
            <th id="actionRequest-respondedAt" class="p-4 text-left min-w-48">{{ __('Responded') }}</th>
          </tr>

          <tr v-for="(actionRequest, index) in actionRequests.data" :class="{'bg-gray-300': index%2 === 0}">
            <td class="p-4 w-10">{{ actionRequest.id }}</td>
            <td class="p-4 text-left w-full">
              <inertia-link :href="actionRequest.url" class="text-coral-400 hover:text-gray-500 font-semibold">
                {{ __(`actionRequestType.${actionRequest.type}`) }}
              </inertia-link>
            </td>
            <td class="p-4 text-left min-w-48">
              <a v-if="actionRequest.type !== 'complete'" target="_blank" class="text-coral-400 hover:text-gray-500 font-semibold" :href="actionRequest.client_url">{{ __('Notification link') }}</a>
              <span v-if="actionRequest.type === 'complete'">-</span>
            </td>
            <td class="p-4 text-left min-w-48">{{ actionRequest.user.name }}</td>
            <td class="p-4 text-left min-w-48">{{ actionRequest.created_at }}</td>
            <td class="p-4 text-left min-w-48">{{ actionRequest.responded_at ? actionRequest.responded_at : '-' }}</td>
          </tr>
        </table>
        <div v-else>
          {{ __('No notifications just yet') }}
        </div>

        <pagination :links="actionRequests.meta.links"/>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';
import JobMenu from '../Jobs/JobMenu';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Order #:id notifications', { id: this.job.id }),
    };
  },
  props: {
    job: Object,
    actionRequests: Object,
  },
  components: {
    Layout,
    Pagination,
    Icon,
    JobMenu,
  },
};
</script>
